import { CircularProgress, Stack } from "@mui/joy";

export function Loading({size}) {
    return <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        height="100%"
    ><CircularProgress size={size}/></Stack>
}